export default "__VITE_ASSET__74b8e6f5__"